// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from 'firebase/storage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAVdKKolKUjtVcYadt8-DTcVMlhsawwWPY",
    authDomain: "event-finder12.firebaseapp.com",
    projectId: "event-finder12",
    storageBucket: "event-finder12.appspot.com",
    messagingSenderId: "924625058725",
    appId: "1:924625058725:web:7b4271e0b30cc21471c64c",
    measurementId: "G-J2JRHMTRNZ"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const auth = getAuth(app);
export { storage,auth };
